import { useEffect, useState } from "react";

export function useQaView(): {
  enabled: boolean;
  loading: boolean;
  exit: () => void;
} {
  const [qaViewEnabled, setQaViewEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  // We are purposely using sessionStorage, as opposed to local storage or cookies, so that
  // this setting doesn't get stuck on when people aren't expecting
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const param = searchParams.get("qaView");

    if (param === "true") {
      sessionStorage.setItem("qaView", "true");
      setQaViewEnabled(param === "true");
      setLoading(false);
      return;
    }

    if (param === "false") {
      sessionStorage.setItem("qaView", "false");
      setQaViewEnabled(false);
      setLoading(false);
      return;
    }

    const stored = sessionStorage.getItem("qaView");
    const isEnabled = stored === "true";
    setQaViewEnabled(isEnabled);

    if (isEnabled && !searchParams.has("qaView")) {
      searchParams.set("qaView", "true");
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }

    setLoading(false);
  }, [qaViewEnabled]);

  const exitQaView = () => {
    sessionStorage.setItem("qaView", "false");
  };

  return { enabled: qaViewEnabled, loading, exit: exitQaView };
}
